// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__17lqG","log":"ModalInventoryLogs_log__2CSrx","date":"ModalInventoryLogs_date__33a4c","userName":"ModalInventoryLogs_userName__1VgWk"};